<template>
    <v-app-bar app dark clipped="true" color="primary">
        <!--<v-app-bar-nav-icon v-on:click="showClick" @click.stop="drawer = !drawer; console.log('Drawer State: ' + drawer);"></v-app-bar-nav-icon>-->
        <v-toolbar-title>
            Wyoming Department of Health - Medicaid Waiver Participant Portal
        </v-toolbar-title>
    </v-app-bar>
    <v-navigation-drawer location="left" color="secondary" permanent>


        <v-list-item class="d-flex justify-center align-center">
            <v-img src="@/assets/wdh_logo.png" alt="Wyoming Department of Health" style="width: 100px; max-height: 200px;" />
        </v-list-item>
        <v-list :lines="false"
                density="compact"
                nav>
            <v-list-item
                         color="primary"
                         class="text-left">
                <template v-slot:prepend>
                    <v-icon icon="mdi-login" />
                </template>
                <v-list-item-title class="text-left">
                    <AuthenticationButton />
                </v-list-item-title>
            </v-list-item>
            <v-list-item v-for="(item, i) in items"
                         :key="i"
                         :value="item"
                         :to="item.route"
                         :prepend-icon="item.icon"
                         color="primary"
                         class="text-left">
                <template v-slot:prepend>
                    <v-icon :icon="item.icon"></v-icon>
                </template>

                <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item>
            <v-list-item v-for="(item, i) in registeredItems"
                         :key="i"
                         :value="item"
                         :to="item.route"
                         :prepend-icon="item.icon"
                         color="primary"
                         class="text-left">
                <template v-slot:prepend>
                    <v-icon :icon="item.icon"></v-icon>
                </template>

                <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<style>
</style>

<script setup lang="ts">
    import { ref, watch } from 'vue';
    import AuthenticationButton from "@/ComponentsChild/AuthenticationButton.vue";

    const drawer = ref(false);
    const group = ref(null);
    //let registered = ref(true)

    const items = ref([
        { icon: 'mdi-home', text: 'Home', route: '/' },
        { icon: 'mdi-account-circle', text: 'Register', route: 'register' },
        { icon: 'mdi-file-document', text: 'Application', route: 'application' },

    ]);

    const registeredItems = ref([
        { icon: 'mdi-file-document-check', text: 'Application Status', route: 'application-status' }
    ])

    watch(group, () => {
        drawer.value = false;
    });

</script>

